import type {CompletedReview, ReviewState} from '../../../../../page-data/payloads/review-requests'
import styles from './ReviewHeaderContent.module.css'
import {ReviewerLink} from './ReviewerLink'

interface ReviewHeaderTitleProps {
  reviews: CompletedReview[]
  state: ReviewState
}

const LABELS: Partial<Record<ReviewState, {singular: string; plural: string}>> = {
  approved: {singular: 'approval received', plural: 'approvals received'},
  changes_requested: {singular: 'change requested', plural: 'changes requested'},
  commented: {singular: 'comment review', plural: 'comment reviews'},
}

/**
 * Renders the title for a review group header:
 * - 1 reviewer: "1 {singular}", middot, then the reviewer identity inline
 * - N reviewers: "N {plural}"
 */
export function ReviewHeaderTitle({reviews, state}: ReviewHeaderTitleProps) {
  const {singular: singularLabel = state, plural: pluralLabel = state} = LABELS[state] ?? {}
  const count = reviews.length
  const [first] = reviews

  if (count === 1 && first) {
    return (
      <>
        <span className={styles.title}>1 {singularLabel}</span>
        <span aria-hidden="true" className={styles.middot}>
          ·
        </span>
        <span className={styles.reviewerIdentityWrapper}>
          <ReviewerLink reviewer={first.reviewer} />
        </span>
      </>
    )
  }

  return <span className={styles.title}>{`${count} ${pluralLabel}`}</span>
}
